import React, { useRef, useEffect } from "react";

import { Box } from "@mui/material";

import "./scrollProgress.scss";

const ScrollProgress = ({ progress }) => {
    const ref = useRef();

    useEffect(() => {
        ref.current.style.width = `${progress}%`;
    }, [ref.current]);

    if (ref.current) {
        ref.current.style.width = `${progress}%`;
    }

    return (
        <Box className="progressBar fullWidth">
            <Box ref={ref} className="progress fullHeight textCenter"></Box>
        </Box>
    );
};

export default ScrollProgress;
